import type { MagicRecipe } from './vfx-recipe-types';

export interface MagicArea {
  schema: 'ft.vfx.area.v1'; encounterId: string; shape: 'cone'|'line'|'sphere'|'circle'|'cylinder'|'cube'|'square';
  origin: {x:number;y:number;z:number}; end: {x:number;y:number;z:number}; distance:number; depth:number; height:number;
}
export interface AreaCastVfx { itemId: string; recipe: MagicRecipe; area: MagicArea; recipientUserIds: string[] }
export function validMagicArea(area: MagicArea | undefined): area is MagicArea {
  return !!area && area.schema === 'ft.vfx.area.v1' && ['cone','line','sphere','circle','cylinder','cube','square'].includes(area.shape)
    && [area.origin?.x,area.origin?.y,area.origin?.z,area.end?.x,area.end?.y,area.end?.z].every(Number.isFinite)
    && [area.distance,area.depth].every(n => Number.isFinite(n) && n > 0)
    && (Number.isFinite(area.height) && area.height > 0 || area.shape === 'cylinder' && (area.height === 0 || area.height === undefined))
    && (!['cone','line'].includes(area.shape) || Math.hypot(area.end.x-area.origin.x,area.end.y-area.origin.y) > 1e-9);
}
export function magicAreaCenter(area: MagicArea): {x:number;y:number;z:number} {
  return {x:(area.origin.x+area.end.x)/2,y:(area.origin.y+area.end.y)/2,z:(area.origin.z+area.end.z)/2};
}
/** Use the viewer's current point-sight reader, never the caster's or an affected creature's visibility. */
export function magicAreaPerceived(area: MagicArea, projection: {authority:string;viewerCreatureIds:string[]} | null,
  sees?: (id:string, points:Array<{x:number;y:number;z:number}>) => Array<boolean|null> | null): boolean {
  if (!validMagicArea(area) || !projection) return false;
  if (projection.authority === 'gm-complete') return true;
  return projection.viewerCreatureIds.some(id => sees?.(id, [magicAreaCenter(area)])?.[0] === true);
}
